import { BigDecimal } from "@solomon-labs/bigdecimal";

/**
 * Largest first, for the Balances list. A row whose amount is unknown
 * (null, still loading or failed) goes last: it has no place in the
 * ordering, and floating it to the top would put a blank above the
 * figures a user came to read. Ties keep their incoming order.
 */
export function sortByAmountDesc<T extends { amount: string | null }>(rows: T[]): T[] {
    return rows
        .map((row, index) => ({ row, index, value: row.amount === null ? null : new BigDecimal(row.amount) }))
        .sort((a, b) => {
            if (a.value === null || b.value === null) {
                if (a.value === b.value) return a.index - b.index;
                return a.value === null ? 1 : -1;
            }
            if (a.value.gt(b.value)) return -1;
            if (a.value.lt(b.value)) return 1;
            return a.index - b.index;
        })
        .map(({ row }) => row);
}
